"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/alert/style/index.js
// module id = 186
// module chunks = 1